"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

import { ThemeToggle } from "./ThemeToggle";

const NAV_ITEMS = [
  { href: "#problems", label: "Проблемы" },
  { href: "#how", label: "Как это работает" },
  { href: "#audience", label: "Кому подходит" },
  { href: "#values", label: "Возможности" },
  { href: "#pricing", label: "Тарифы" },
  { href: "#faq", label: "Вопросы" },
  { href: "/blog", label: "Блог" },
];

export function Header({ isLoggedIn = false }: { isLoggedIn?: boolean }) {
  const [open, setOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const pathname = usePathname();
  // На внутренних страницах (блог) якоря ведут на главную: /#values
  const toHref = (href: string) => (href.startsWith("#") && pathname !== "/" ? `/${href}` : href);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && open) {
        setOpen(false);
        toggleRef.current?.focus();
      }
    };
    const onResize = () => {
      if (window.innerWidth >= 1024) setOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    window.addEventListener("resize", onResize);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("resize", onResize);
    };
  }, [open]);

  return (
    <header className="site-header" id="top">
      <div className="container header-inner">
        <a className="brand" href={toHref("#top")} aria-label="СЛОТИСЛОТ — на главную">
          <img
            className="brand__logo brand__logo--light"
            src="/landing/logo-light.svg"
            alt="СЛОТИСЛОТ"
            width={132}
            height={24}
          />
          <img
            className="brand__logo brand__logo--dark"
            src="/landing/logo-dark.svg"
            alt=""
            width={132}
            height={24}
            aria-hidden="true"
          />
        </a>

        <nav
          className={`nav${open ? " is-open" : ""}`}
          id="primary-nav"
          aria-label="Основная навигация"
          onClick={(event) => {
            if (event.target instanceof Element && event.target.closest("a")) setOpen(false);
          }}>
          <ul className="nav__list">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a href={toHref(item.href)}>{item.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="header-actions">
          <ThemeToggle />
          {isLoggedIn ? (
            <a className="btn btn--primary btn--sm header-cta" href="/event-types">
              Кабинет
            </a>
          ) : (
            <a className="btn btn--primary btn--sm header-cta" href="/signup" data-signup>
              Начать бесплатно
            </a>
          )}
          <button
            ref={toggleRef}
            type="button"
            className="menu-toggle"
            data-menu-toggle
            aria-expanded={open}
            aria-controls="primary-nav"
            aria-label={open ? "Закрыть меню" : "Открыть меню"}
            onClick={() => setOpen((value) => !value)}>
            <span className="menu-toggle__bars" aria-hidden="true" />
          </button>
        </div>
      </div>
    </header>
  );
}
